import script from "./SpecialtemRollerView.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialtemRollerView.vue?vue&type=script&setup=true&lang=js"

import "./SpecialtemRollerView.vue?vue&type=style&index=0&id=d0f04824&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f04824"]])

export default __exports__